import React from 'react'
import PropTypes from 'prop-types'
import { withCookieConsent } from 'LiveBoard/hocs'
import withOutsideClickHandler from 'shared/hocs/withOutsideClickHandler'
import CallToActionContainer from 'LiveBoard/containers/CallToActionContainer'
import { CTA_AREAS } from 'LiveBoard/components/shared/CallToAction/constants'
import { PersonalDetails } from 'LiveBoard/components/shared/SellerCard'
import { ContactDetails } from './ContactDetails'
import { LIVE_BOARD_CLASSNAMES } from 'shared/constants'

import style from './style.css.scss'

class SellerCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      isPeeking: false
    }
    this.closeEvent = null
  }

  componentDidMount() {
    const {
      provideOutsideClickHandler, provideContainer, expandCard
    } = this.props
    provideOutsideClickHandler(this.handleClose)
    provideContainer(this.container)
    !expandCard && window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    const {
      provideContainer, provideOutsideClickHandler, expandCard
    } = this.props
    provideOutsideClickHandler(null)
    provideContainer(null)
    !expandCard && window.removeEventListener('scroll', this.handleScroll)
  }

  closePeek = () => {
    this.cancelClosePeek()
    this.closeEvent = setTimeout(() => this.setState({isPeeking: false}), 2000)
  }

  cancelClosePeek = () => {
    this.closeEvent && clearTimeout(this.closeEvent)
  }

  handleScroll = () => {
    !this.state.isPeeking && this.setState({isPeeking: true})
    const scrollPosition = window.scrollY + window.innerHeight
    const fullHeight = document.body.scrollHeight
    const scrolledToBottom = scrollPosition >= fullHeight - style.sellerCardHeight
    scrolledToBottom ? this.cancelClosePeek() : this.closePeek()
  }

  handleClose = () => {
    this.setState({ isOpen: false })
    this.handleScroll()
  }

  handleOpen = () => {
    const { onCookieConsent, onClick } = this.props
    this.cancelClosePeek()
    onCookieConsent()
    this.setState({ isOpen: true })
    onClick ? onClick() : this.setState({ isOpen: !this.state.isOpen })
  }

  toggleCard = () => {
    this.state.isOpen ? this.handleClose() : this.handleOpen()
  }

  render() {
    const { seller, config, themeColorHex, expandCard } = this.props
    const customCTAButton = <span className='icon-message'/>
    const openCard = expandCard || this.state.isOpen
    const belowFold = !expandCard && !this.state.isPeeking

    return (
      <section
        className={`${LIVE_BOARD_CLASSNAMES.contact_card} ${belowFold ? 'below-fold' : ''}`}
        onClick={this.toggleCard}
        ref={ref => this.container = ref}>
        <div className='decor-line' style={{ borderLeftColor: themeColorHex }} />
        <PersonalDetails seller={seller} />
        <div className={`contact-wrapper ${openCard ? 'open-card' : ''}`}>
          { config.cta.show &&
            <CallToActionContainer
              config={{...config.cta}}
              area={CTA_AREAS.header}
              themeColorHex={themeColorHex} />
          }
          <ContactDetails seller={seller} />
        </div>
      </section>
    )
  }
}

SellerCard.propTypes = {
  config: PropTypes.object.isRequired,
  seller: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  provideOutsideClickHandler: PropTypes.func.isRequired,
  provideContainer: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  expandCard: PropTypes.bool,
  onCookieConsent: PropTypes.func.isRequired
}

export default withCookieConsent(withOutsideClickHandler(SellerCard))
